"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputEl = void 0;
require("./input.scss");
class inputEl {
    static render(inputType, valueName) {
        const input = document.createElement('input');
        input.className = 'input-field';
        input.id = valueName;
        input.name = valueName;
        input.type = inputType;
        input.placeholder = `enter your ${valueName}`;
        return input;
    }
}
exports.inputEl = inputEl;
